/**
 * KanbanIndicator — 0258 D2: Indicador cuando Kanban con Agenda activa
 * Muestra perfil activo y que las tarjetas se mueven automáticamente.
 */
import React from "react";
import { Paper, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";

const useStyles = makeStyles((theme) => ({
  indicator: {
    padding: theme.spacing(1.5, 2),
    marginBottom: theme.spacing(2),
    backgroundColor: theme.mode === "dark" ? "rgba(16,185,129,0.16)" : "#ecfdf5",
    border: `1px solid ${theme.mode === "dark" ? "#334155" : "#a7f3d0"}`,
    borderRadius: 14,
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    boxShadow: "none",
  },
  icon: {
    color: theme.palette.success.main,
    fontSize: 24,
    flexShrink: 0,
  },
  text: {
    fontWeight: 500,
  },
  subtext: {
    fontSize: "0.8rem",
    color: theme.palette.text.secondary,
    marginTop: 2,
  },
}));

export default function KanbanIndicator({ profileName }) {
  const classes = useStyles();

  return (
    <Paper className={classes.indicator} elevation={0}>
      <CheckCircleIcon className={classes.icon} />
      <div>
        <Typography variant="subtitle2" className={classes.text}>
          Kanban según perfil: {profileName || "Perfil activo"}
        </Typography>
        <Typography variant="caption" className={classes.subtext}>
          Las tarjetas se mueven automáticamente al cambiar el estado de la cita.
        </Typography>
      </div>
    </Paper>
  );
}
